import { h } from 'preact';
import { Header } from '@albelli/arc-3-react';
import '@albelli/arc-3/lib/core.css';
import '@albelli/arc-3/lib/icon.css';
import 'keen-slider/keen-slider.min.css';

const HeaderPart = ({ top, mainMenu, vendor }) => (
    <Header
        topBar={top}
        mainUrl={`https://${vendor}`}
        menu={mainMenu}
        isAuthenticated={false}
        localizedMenuName='MENU'
        vendor={vendor}
    />
);

export default HeaderPart;
